<template>
    <div class="pt-3" :class="((me) ? '' : 'p-5')">

        <div v-if="shouldShowChatConversation" @click.self="shouldShowChatConversation = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_chat_conversation" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="chat-dialog-messages-list" style="max-height: 500px; overflow: auto;">
                                    <div>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in bland_transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.role == 'assistant' || !item.role"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.role == 'user'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.custom_name">
                                                        <span class="mr-auto primary-color text-bold">{{ item.custom_name }}</span>
                                                    </span>
                                                    <span v-else>
                                                        <span v-if="!item.role" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                        <span v-else>
                                                            <span v-if="item.role == 'assistant'" class="mr-auto primary-color text-bold">AI Agent</span>
                                                            <span v-else class="mr-auto warning-color text-bold">Customer</span>
                                                        </span>
                                                    </span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp || item.created_at) }} . </span>
                                                    <div class="text-sm">{{ item.content }} </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="shouldShowChatConversation = false">
                            CLOSE
                        </button>

                        <button
                                class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                                :class="{ spinner: sendingAiMessage }"
                                @click="sendAiReply()"
                                :disabled="!new_ai_message"
                        >
                            SEND
                        </button>

                        <div style="float: right; padding-right: 30px; padding-top: 6px;">
                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                        </div>

                        <div class="clearfix"></div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

        <div v-if="showBlandRecording" @click.self="showBlandRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-2/3 lg:w-2/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                        <div class="float-right -mb-4" style="position: relative;">
                            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->

                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="translateTexts('bland', 'spanish')">
                                <i class="mdi mdi-text-box-edit-outline"></i> TRANSLATE TO ENGLISH
                            </button>
                        </div>

                        <div class="float-right -mb-4" style="position: relative;">
                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="ai_messages_lead.show_ai_feedback = !ai_messages_lead.show_ai_feedback || true;">
                                <i class="mdi mdi-robot-outline"></i>
                                &nbsp;
                                <span v-if="ai_messages_lead.ai_feedback_urgent">🚨</span>
                                &nbsp;
                                <strong v-if="ai_messages_lead.ai_feedback">AI FEEDBACK</strong><span v-else="">AI FEEDBACK</span>
                            </button>

                            <div v-show="ai_messages_lead.show_ai_feedback" style="position: absolute; background: #FFFFFF; padding: 10px; border: solid 1px #CCCCCC; width: 250px; z-index: 1; margin-top: 40px;">
                                <textarea v-model="ai_messages_lead.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                                <br />

                                <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_feedback_urgent" label="Urgent"></v-switch>

                                <br />

                                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(ai_messages_lead)">
                                    SAVE
                                </button>

                                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 w-full w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="ai_messages_lead.show_ai_feedback = false;">
                                    CLOSE
                                </button>
                            </div>
                        </div>

                    <div style="clear: both; padding-top: 10px;"></div>

                    <div>
                        <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="bl-audio-el-here"></div>
                            </div>
                            <div class="w-full">
                                <hr />
                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div v-if="bland_recording_data.lead_type == 'PHONE_CALL'">
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full lg:w-1/2'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in bland_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                                    v-if="index !== 'messages'"
                                                            >
                                                                <b-avatar v-if="item.speaker == 'A'"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, bland_recording_data.transcription[0].start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                                <div :class="'w-full lg:w-1/2 pl-3'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Summary</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.summary || "No summary found." }}</div>

                                                    <!-- <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Sentiment</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.sentiment || "UNKNOWN" }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Topics Discussed</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.topics_discussed || "No topics discussed." }}</div>

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Issues Raised</div>

                                                    <div style="font-size: 12px;">{{ bland_recording_data.issues_raised || "No issues raised." }}</div> -->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Customer Information</div>

                                                    <div style="font-size: 12px;">
                                                        <strong>Customer's name:</strong> {{ bland_recording_data.customer_name || "-" }}
                                                        <br />
                                                        <strong>Customer's email:</strong> {{ bland_recording_data.customer_email || "-" }}
                                                        <br />
                                                        <strong>Customer's phone:</strong> {{ bland_recording_data.ai_provided_phone_number || "-" }}
                                                        <br />
                                                        <strong>Service needed:</strong> {{ bland_recording_data.job_type || "-" }}
                                                        <br /><br />
                                                        <strong>Call ended by:</strong> {{ bland_recording_data.call_ended_by || "-" }}
                                                    </div>

                                                    <!--<div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Analysis</div>

                                                    <div v-if="bland_recording_data.analysis" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.analysis" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No analysis detected.</div>-->

                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Variables</div>

                                                    <div v-if="bland_recording_data.variables" style="font-size: 12px;">
                                                        <div v-for="(item, index) in bland_recording_data.variables" :key="'variable-' + index">
                                                            <strong>{{ index }}: </strong> {{ item }} <br />
                                                        </div>
                                                    </div>
                                                    <div v-else style="font-size: 12px;">No variables.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <b-list-group>
                                                <b-list-group-item
                                                    v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                            
                                                        class="d-flex align-items-center mb-4 pb-4"
                                                        style="border: none; border-bottom: solid 1px #ededed;"
                                                >

                                                    <b-avatar v-if="(!item.is_bland && item.sender != 'bot') || item.is_person"
                                                            text="S1"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <b-avatar v-if="(item.is_bland || item.sender == 'bot') && !item.is_person"
                                                            text="S2"
                                                            class="mr-3 call-info-avatar"
                                                    ></b-avatar>
                                                    <div>
                                                        <span v-if="item.is_person" class="mr-auto primary-color text-bold">{{ me.first_name }} {{ me.last_name }}</span>
                                                        <span v-if="(item.is_bland || item.sender == 'bot') && !item.is_person" class="mr-auto primary-color text-bold">AI Agent</span>
                                                        <span v-if="!item.is_bland && item.sender != 'bot' && !item.is_person" class="mr-auto warning-color text-bold">Customer</span>

                                                        <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.timestamp) }} . </span>
                                                        <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                        <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                        <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                        <div class="text-sm">
                                                            {{ item.message }}
                                                        </div>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </div>
                                </div>

                                <div v-show="bland_recording_data.transcription.messages" class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showBlandRecording = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                            :class="{ spinner: sendingAiMessage }"
                            @click="sendAiReply()"
                            :disabled="!new_ai_message"
                    >
                        SEND
                    </button>

                    <div style="float: right; padding-right: 30px; padding-top: 6px;">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                    </div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaRecordings" @click.self="showLsaRecordings = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_recordings" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full mb-4">
                                <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                                <div id="lsa-audio-el-here"></div>

                                <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4" role="alert">
                                    <div>According to Google's policy, you must be logged in to your LSA account in this browser. Please make sure you are logged in on <a href="https://ads.google.com/localservices" target="lsa-account-login">https://ads.google.com/localservices</a> in order to play the recordings in your software.</div>
                                </div>

                                <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                    <div v-if="!lsa_recording_data.transcription" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <div>
                                            <div class="flex flex-row flex-wrap w-full">
                                                <div :class="'w-full'">
                                                    <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                    <br />
                                                    <div>
                                                        <b-list-group>
                                                            <b-list-group-item
                                                                v-for="(item, index) in lsa_recording_data.transcription" :key="index"
                                                        
                                                                    class="d-flex align-items-center mb-4 pb-4"
                                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                                                    v-if="index !== 'messages'"
                                                            >
                                                                <b-avatar v-if="(item.speaker == 'A' || item.speaker == 'C')"
                                                                        text="S1"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <b-avatar v-if="item.speaker == 'B'"
                                                                        text="S2"
                                                                        class="mr-3 call-info-avatar"
                                                                ></b-avatar>
                                                                <div>
                                                                    <span v-if="(item.speaker == 'A' || item.speaker == 'C') && lsa_item.sources.indexOf('bland') !== -1" class="mr-auto primary-color text-bold">AI</span>
                                                                    <span v-if="item.speaker == 'A' && lsa_item.sources.indexOf('bland') === -1" class="mr-auto primary-color text-bold">Advertiser</span>
                                                                    <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                    <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, lsa_recording_data.transcription[0].start) }} . </span>
                                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                    <div class="text-sm">{{ item.text }}</div>
                                                                </div>
                                                            </b-list-group-item>
                                                        </b-list-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaRecordings = false">
                        CLOSE
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="showLsaMessages" @click.self="showLsaMessages = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 65px); overflow: auto;">

                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_lsa_messages" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="lsa-dialog-messages-list" style="max-height: 450px; overflow: auto;">
                                    <div v-if="lsa_messages_displayed.length == 0" class="text-sm" style="text-align: center;">
                                        <br />
                                        No transcription available.
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in lsa_messages_displayed" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.participant_type == 2"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.participant_type == 3"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.participant_type == 2" class="mr-auto primary-color text-bold">Advertiser</span>
                                                    <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.event_time) }} . </span>
                                                    <div class="text-sm" v-html="item.text"></div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div>
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_lsa_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaMessages = false">
                        CLOSE
                    </button>

                    <button
                            class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4"
                            :class="{ spinner: sendingLsaMessage }"
                            @click="sendLsaReply()"
                            :disabled="!new_lsa_message"
                    >
                        SEND
                    </button>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

            <div v-if="show_notes_dialog" @click.self="show_notes_dialog = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                        Notes

                        <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_notes_dialog = false"><i class="mdi mdi-close"></i></a>
                    </div>

                    <div class="p-6" style="position: relative; overflow: auto;">

                        <div style="clear: both;"></div>

                        <div>

                            <div style="font-size: 12px; padding-bottom: 20px;">
                                <div v-if="notes_lead.notes.length == 0">
                                    No notes found.
                                </div>

                                <div v-else>
                                    <div v-for="(note, note_index) in notes_lead.notes" style="clear: both; padding-bottom: 10px;">
                                        <div style="float: left; width: calc(100% - 220px);">
                                            {{ note.note }}
                                        </div>

                                        <div style="float: right; width: 200px; text-align: right;">
                                            [{{ formatDate(note.timestamp) }}]

                                            &nbsp;&nbsp;

                                            <a href="javascript: void(0);"><i class="mdi mdi-delete-outline" style="color: red;" @click="deleteNote(note_index)"></i></a>
                                        </div>

                                        <div style='clear: both;'></div>
                                    </div>

                                    <div style='clear: both;'></div>
                                </div>
                            </div>

                            <v-textarea
                                clearable
                                outlined
                                dense
                                hide-details
                                label="Add Note"
                                v-model="new_note"

                                class="white border border-white"
                            ></v-textarea>
                            
                        </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingNote}" @click="saveNote">
                            ADD
                        </button>

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_notes_dialog = false">
                            CLOSE
                        </button>

                    <div class="clearfix"></div>

                    </div>
                </div>
            </div>

            <div v-if="show_photos_dialog"
                 @click.self="show_photos_dialog = false"
                 class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center"
                 style="background-color: rgba(0,0,0,.2);">

                <div class="w-full sm:w-1/2 lg:w-1/2 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="rg-modal-header">
                        Photos
                        <a href="javascript:void(0);" class="rg-modal-close-btn" @click="show_photos_dialog = false">
                            <i class="mdi mdi-close"></i>
                        </a>
                    </div>

                    <div class="p-6" style="position: relative; overflow: auto; max-height: 400px;">

                        <!-- NO PHOTOS -->
                        <div v-if="photos.length == 0" style="font-size: 13px;">
                            No photos uploaded.
                        </div>

                        <!-- PHOTO GRID -->
                        <div v-else class="grid grid-cols-2 md:grid-cols-3 gap-4">
                            <div v-for="(photo, index) in photos" :key="index" style="position: relative;">
                                
                                <img :src="photo"
                                     style="width: 100%; height: 150px; object-fit: cover; border-radius: 6px;" />

                                <button @click="removePhoto(index)"
                                        style="position: absolute; top: 5px; right: 5px; background: red; color: white; border: none; border-radius: 50%; width: 25px; height: 25px;">
                                    ✕
                                </button>

                            </div>
                        </div>

                        <!-- FILE INPUT -->
                        <div class="mt-4">
                            <input type="file"
                                   accept="image/*"
                                   @change="handlePhotoUpload"
                                   multiple :disabled="uploading" />

                            <div v-if="uploading" class="pt-3">Uploading... please wait</div>
                        </div>

                    </div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right"
                                :class="{'spinner': savingPhotos}"
                                @click="savePhotos">
                            SAVE
                        </button>

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right"
                                @click="show_photos_dialog = false">
                            CLOSE
                        </button>

                        <div class="clearfix"></div>

                    </div>

                </div>
            </div>


        <div style="float: right;">
            Month:
            <!-- Render only when months exist -->
            <select v-if="months.length" v-model="selectedMonth" style="background: #FFFFFF; border: solid 1px #CCCCCC; border-radius: 5px; padding: 5px;" @change="getMessages(); updateMonthDates(selectedMonth)">
              <option
                v-for="month in months"
                :key="month.value"
                :value="month.value"
              >
                {{ month.label }}
              </option>
            </select>

            <!-- Optional debug -->
            <!-- <pre>{{ selectedMonth }}</pre> -->
        </div>

        <h1 class="text-lg font-semibold mb-3">
            
            <span v-if="loading">Loading...</span>
            <span v-else>
                <span v-if="me">
                    <span>{{ company_name }} - {{ me.city }}<span v-if="me.integrations && me.integrations.google_ads && me.integrations.google_ads.settings.selected_client_id"> - {{ me.integrations.google_ads.settings.selected_client_id }}</span></span>
                </span>
                <span v-else>
                    {{ company_name }} - Monthly Report
                </span>
            </span>

            <v-chip
                    class="ma-2"
                    color="#44468F"
                    outlined
                    small
            >
                {{ messages.length }}
            </v-chip>
        </h1>
        <hr class="border-b border-gray-100 mb-3">

        <template>
          <v-expansion-panels v-model="panel" accordion flat dense>
              <v-expansion-panel>
              <v-expansion-panel-header>Stats</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <div v-if="!loading && dashboard_data" class="space-y-6 pt-3">

                    <!-- LEADS -->
                    <section>
                      <div class="flex flex-wrap -mx-2">
                        <StatCard
                          title="Total Leads"
                          icon="mdi-account-multiple"
                          :value="dashboard_data.total_leads"
                          :current="dashboard_data.total_leads"
                          :previous="dashboard_data_prev.total_leads"
                          :change="comparisons.total_leads"
                        />

                        <StatCard
                          title="Total Calls"
                          icon="mdi-phone"
                          :value="dashboard_data.total_calls"
                          :current="dashboard_data.total_calls"
                          :previous="dashboard_data_prev.total_calls"
                          :change="comparisons.total_calls"
                          :tooltiptext="'Total Calls might be different than Total Leads because a lead can call multiple times'"
                        />

                        <StatCard
                          title="Connected Calls"
                          icon="mdi-phone-check"
                          :value="dashboard_data.total_connected_calls"
                          :current="dashboard_data.total_connected_calls"
                          :previous="dashboard_data_prev.total_connected_calls"
                          :change="comparisons.total_connected_calls"
                        />

                        <StatCard
                          title="Charged"
                          icon="mdi-cash-check"
                          :value="dashboard_data.charged_leads_total"
                          :current="dashboard_data.charged_leads_total"
                          :previous="dashboard_data_prev.stats.charged_leads_total"
                          :change="comparisons.charged_leads_total"
                          :tooltiptext="'These are the leads that were permanently charged by Google LSA'"
                        />

                        <StatCard
                          title="Message Leads"
                          icon="mdi-message-text"
                          :value="dashboard_data.total_message_leads"
                          :current="dashboard_data.total_message_leads"
                          :previous="dashboard_data_prev.total_message_leads"
                          :change="comparisons.total_message_leads"
                        />

                        <StatCard
                          title="Lead Quality"
                          icon="mdi-poll"
                          :value="dashboard_data.lead_quality"
                          :current="dashboard_data.lead_quality"
                          :previous="dashboard_data_prev.lead_quality"
                          :change="comparisons.lead_quality"
                        />

                        <StatCard
                          title="Not Charged"
                          icon="mdi-cash-remove"
                          :value="dashboard_data.not_charged_leads"
                          :current="dashboard_data.not_charged_leads"
                          :previous="dashboard_data_prev.not_charged_leads"
                          :change="comparisons.not_charged_leads"
                          :tooltiptext="'These are the leads that were not charged by LSA from the moment the leads were created'"
                        />

                        <StatCard
                          title="Qualified Leads"
                          icon="mdi-check-circle"
                          :value="dashboard_data.stats.charged_leads"
                          :current="dashboard_data.stats.charged_leads"
                          :previous="dashboard_data_prev.stats.charged_leads"
                          :change="comparisons.charged_leads"
                        />

                        <StatCard
                          title="Credited"
                          icon="mdi-cash-refund"
                          :value="dashboard_data.stats.approved_disputes"
                          :current="dashboard_data.stats.approved_disputes"
                          :previous="dashboard_data_prev.stats.approved_disputes"
                          :change="comparisons.approved_disputes"
                          :total_refunds="dashboard_data.stats.total_approved_disputes"
                          :refunds_amount="dashboard_data.refunds_amount"
                          :refunds_amount_total="dashboard_data.refunds_amount_total"
                        />

                        <!-- <StatCard
                          title="Conversion Rate"
                          icon="mdi-percent"
                          :value="dashboard_data.stats.conversion + '%'"
                          :current="dashboard_data.stats.total_converted_value"
                          :previous="dashboard_data_prev.stats.total_converted_value"
                          :change="comparisons.total_converted_value"
                        />
                        <StatCard
                          title="Response Rate"
                          icon="mdi-clock-check"
                          :value="dashboard_data.stats.lsa_response_rate + '%'"
                          :current="dashboard_data.stats.lsa_response_rate"
                          :previous="dashboard_data_prev.stats.lsa_response_rate"
                          :change="comparisons.lsa_response_rate"
                        />

                        <StatCard
                          title="Under 30s Response"
                          icon="mdi-timer"
                          :value="dashboard_data.stats.lsa_30_seconds_response_rate + '%'"
                          :current="dashboard_data.stats.lsa_30_seconds_response_rate"
                          :previous="dashboard_data_prev.stats.lsa_30_seconds_response_rate"
                          :change="comparisons.lsa_30_seconds_response_rate"
                        />

                        <StatCard
                          title="Message Response Time"
                          icon="mdi-message-clock"
                          :value="dashboard_data.stats.lsa_messages_response_rate + ' hrs'"
                          :current="dashboard_data.stats.lsa_messages_response_rate"
                          :previous="dashboard_data_prev.stats.lsa_messages_response_rate"
                          :change="comparisons.lsa_messages_response_rate"
                          reverse
                        /> -->
                        <!-- <StatCard
                          title="Impressions"
                          icon="mdi-eye"
                          :value="dashboard_data.stats.total_impressions.toLocaleString()"
                          :current="dashboard_data.stats.total_impressions"
                          :previous="dashboard_data_prev.stats.total_impressions"
                          :change="comparisons.total_impressions"
                        />

                        <StatCard
                          title="Clicks"
                          icon="mdi-mouse"
                          :value="dashboard_data.stats.total_clicks.toLocaleString()"
                          :current="dashboard_data.stats.total_clicks"
                          :previous="dashboard_data_prev.stats.total_clicks"
                          :change="comparisons.total_clicks"
                        />

                        <StatCard
                          title="Total Cost"
                          icon="mdi-currency-usd"
                          :value="'$' + dashboard_data.stats.total_cost.toLocaleString()"
                          :current="dashboard_data.stats.total_cost"
                          :previous="dashboard_data_prev.stats.total_cost"
                          :change="comparisons.total_cost"
                        /> -->
                      </div>
                    </section>

                  </div>

              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>

          <v-expansion-panels v-model="panel" accordion flat dense>
              <v-expansion-panel>
              <v-expansion-panel-header>Metrics Over Time</v-expansion-panel-header>
              <v-expansion-panel-content>
                  <div class="-mr-4">
                  <div class="dashboard-box stats-box w-full p-3">
                    
                    <div v-if="!loading && dashboard_data" class="flex flex-row flex-wrap mt-5">
                      <div class="dashboard-box stats-box w-full mb-4 pr-0 mb-5">
                          <v-card
                            class="pa-2"
                            tile
                          >
                            <div class="pl-3 pt-3">
                              <div class="-mt-5 -ml-4 -mb-2">
                                  <apexchart
                                      :options="lineChartMetricsOptions"
                                      :series="lineChartMetricsSeries"
                                      type="line"
                                      height="375"
                                      ref="apexChart"
                                  />

                                  <div class="custom-legend centered">
                                      <div
                                          v-for="item in legendItems"
                                          :key="item.name"
                                          class="custom-legend-item"
                                          :class="{
                                            disabled: item.disabled,
                                            dimmed: hoveredLegend && hoveredLegend !== item.name
                                          }"
                                          @mouseover="handleLegendHover(item)"
                                          @mouseleave="handleLegendLeave"
                                          @click="toggleSeries(item)"
                                        >
                                        <v-tooltip top color="primary">
                                          <template #activator="{ on, attrs }">
                                            <div class="legend-content" v-bind="attrs" v-on="on">
                                              <span
                                                class="legend-dot"
                                                :style="{ backgroundColor: item.color }"
                                              ></span>
                                              <span class="legend-label">{{ item.name }}</span>
                                            </div>
                                          </template>
                                          <span>{{ item.description }}</span>
                                        </v-tooltip>
                                      </div>
                                    </div>
                              </div>
                            </div>
                          </v-card>
                      </div>
                    </div>

                  </div>
                  </div>
              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>

            <div class="dashboard-box">
                <v-card class="pa-2" tile>
                    <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                    <div v-if="!loading" class="p-3">
                        <div v-if="messages.length == 0">
                            <br/><br/><br/><br/>
                            <div class="dashboard-box-iconsquare">
                                <div class="dashboard-box-icon-background"></div>
                                <div class="dashboard-box-icon">
                                    <i class="mdi mdi-phone"></i>
                                </div>
                            </div>
                            <div style="text-align: center;">
                                <div class="pt-2 pb-2">
                                    <strong>No Leads</strong>
                                </div>

                                <div class="text-sm mb-4 text-gray-600">
                                    No leads found for the given period. Refine your search or wait until new leads come in.
                                </div>
                                <br/>
                            </div>
                            <br/><br/><br/><br/><br/>
                        </div>

                        <div v-else style="clear: both; padding-top: 0px;">

                            <div class="mb-3 -mt-1">
                              <div class="float-left">
                                <span style="font-size:13px;color:#555;">
                                  <span style="background:#FFF7CC;border:1px solid #E6D98A;padding:6px 6px; width: 100px; border-radius:3px;margin-right:6px;">
                                    Yellow Highlighted Leads - New leads from the last 2 weeks
                                  </span>
                                </span>
                              </div>

                              <div class="legend-items float-right pl-5">
                                <div
                                  v-for="item in legend"
                                  :key="item.value"
                                  class="legend-item"
                                >
                                  <span
                                    class="legend-badge"
                                    :class="item.class"
                                  >
                                    {{ item.value }}
                                  </span>
                                  <span class="legend-label">
                                    {{ item.label }}
                                  </span>
                                </div>
                              </div>

                                <div v-if="me" style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="downloadCsv">
                                        <i class="mdi mdi-file-delimited-outline"></i> Download CSV
                                    </div>
                                </div>

                                <div v-if="me" v-show="!isAccelerate()" style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="getMonthlyReport">
                                        <i class="mdi mdi-file-outline"></i> Get Monthly Report
                                    </div>
                                </div>

                                <div v-if="me" v-show="!isAccelerate()" style="float: right; font-size: 12px; line-height: 20px; margin-top: -5px; text-align: right; margin-right: 6px;">
                                    <div class="stats-btn" style="padding: 6px; border: solid 1px #CCCCCC; border-radius: 5px; background: #FFFFFF; padding-left: 10px; padding-right: 10px; cursor: pointer;" @click="sendMonthlyReport">
                                        <i class="mdi mdi-email"></i> Send Monthly Report
                                    </div>
                                </div>

                              <div style="clear: both;"></div>

                                <div style="float: left; padding-top: 15px;" v-show="selected.length > 0">
                                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="trainAgentWithSelectedCalls();">
                                        Train Agent with selected calls
                                    </button>
                                </div>

                              <div style="clear: both;"></div>
                            </div>

                            <v-data-table
                                :headers="headers"
                                :items="messages"
                                :items-per-page="9999"
                                class="rg-datatable elevation-1"
                                mobile-breakpoint="10"
                                v-model="selected"
                                item-key="id"
                                disable-pagination
                                hide-default-footer
                                :item-class="getRowClass"
                                :show-select="((me) ? true : false)"
                                >
                                    <template v-slot:item.customer_name="{ item }">
                                        <span v-if="item.job_type">
                                            {{ item.job_type }} -
                                        </span>
                                        
                                        {{ item.tracking_number || item.customer_phone_number }}

                                        <div v-if="item.customer_address && item.customer_address.trim()" class="customer-address">
                                            <i class="mdi mdi-map-marker-outline" aria-hidden="true"></i>
                                            <span>{{ item.customer_address }}</span>
                                        </div>

                                        <div v-if="item.is_lsa_booked">
                                            <v-chip
                                                small
                                                color="gray lighten-5"
                                                text-color="gray lighten-1"
                                            >
                                                Booked
                                            </v-chip>
                                        </div>
                                    </template>

                                    <template v-slot:item.to="{ item }">
                                        {{ item.to || "-" }}
                                    </template>

                                    <template v-slot:item.sources="{ item }">
                                        <div class="flex items-center gap-2">

                                        <div class="flex items-center gap-2">
                                        <v-tooltip v-for="p in normalizedProviders(item)" :key="p.key" top color="primary">
                                        <template #activator="{ on, attrs }">
                                        <img
                                          v-bind="attrs"
                                          v-on="on"
                                          :src="p.src"
                                          :alt="p.title"
                                          class="rg-channel-icon"
                                          @click="p.onClick && p.onClick(item)"
                                          v-bind:data-lead-id="
                                            ((item.sources || '').toLowerCase().split(',').map(s => s.trim()).includes('bland'))
                                              ? (p.key === 'ai' ? item.id : null)
                                              : (p.key !== 'ai' ? item.id : null)
                                          "
                                          :style="'cursor: initial;' + ((p.title == 'This is a call that we responded to using AI' || p.title == 'This is a Web Chat conversation') ? 'width: 52px; height: 52px; margin-left: -10px;' : '')"
                                        />
                                        </template>
                                        <span>{{ p.title }}</span>
                                        </v-tooltip>

                                        <v-tooltip v-if="item.sources.indexOf('bland') == -1 && item.sources.indexOf('web') == -1" top color="primary">
                                            <template #activator="{ on, attrs }">
                                                <i class="mdi mdi-account" v-bind="attrs" v-on="on" :style="'cursor: initial; font-size: 33px; color: #807d7d; margin-top: 4px;'"></i>
                                            </template>
                                            <span>This is a lead that was answered by a human</span>
                                        </v-tooltip>

                                        <v-tooltip v-if="item.sources.indexOf('web') != -1" top color="primary">
                                            <template #activator="{ on, attrs }">
                                                <i class="mdi mdi-web" v-bind="attrs" v-on="on" :style="'cursor: initial; font-size: 23px; color: #807d7d; margin-top: 4px;'"></i>
                                            </template>
                                            <span>This is a conversation that was answered by our AI Chat Widget</span>
                                        </v-tooltip>

                                        </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_type="{ item }">
                                        <div class="flex items-center gap-2">


                                        <!-- Modality chip (Call / Message / Booking) -->
                                        <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-slate-300 ml-1" style="background-color: #CCCCCC;">
                                        <i v-if="item.lead_type == 'PHONE_CALL'" class="mdi mdi-phone"></i>
                                        <i v-else-if="item.lead_type == 'MESSAGE'" class="mdi mdi-message-text-outline"></i>
                                        <i v-else-if="item.sources == 'web'" class="mdi mdi-chat"></i>
                                        <i v-else class="mdi mdi-information-outline"></i>
                                        <span v-if="item.lead_type == 'PHONE_CALL'">Call</span>
                                        <span v-else-if="item.sources == 'web'">CHAT</span>
                                        <span v-else-if="item.lead_type == 'MESSAGE'">Message</span>
                                        <span v-else-if="item.lead_type == 'BOOKING'">Booking</span>
                                        <span v-else>-</span>
                                        </span>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_creation_date="{ item }">
                                        {{ displayTimestamp(item.lead_creation_date) }}

                                        <div v-show="item.lead_id">
                                            <strong>Lead ID:</strong> {{ item.lead_id }}
                                        </div>

                                        <div v-show="item.lead_source">
                                            <strong>Lead Source:</strong> {{ item.lead_source }}
                                        </div>
                                    </template>

                                    <template v-slot:item.updated_at="{ item }">
                                        {{ displayTimestamp(item.updated_at) }}
                                    </template>

                                    <template v-slot:item.responded_time="{ item }">
                                        <span v-if="item.responded_time !== NULL && item.responded_time !== -1">
                                            <span v-if="item.responded_time > 1000">
                                                {{ parseInt(item.responded_time / 60) }} minutes
                                            </span>
                                            <span v-else>
                                                {{ item.responded_time }} seconds
                                            </span>
                                        </span>
                                        <span v-else>N/A</span>
                                    </template>
                                    
                                    <template v-slot:item.geo="{ item }">
                                        <span v-if="item.geo">
                                            {{ item.geo.split(',')[0] }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>
                                    
                                    <template v-slot:item.charge_status="{ item }">
                                        <span v-if="item.charge_status == 'CHARGED'">
                                            <span v-if="item.dispute_status == 'APPROVED'">
                                                <v-chip
                                                    small
                                                    color="green lighten-4"
                                                    text-color="green lighten-1"
                                                >
                                                    Credited
                                                </v-chip>
                                            </span>
                                            <span v-else>
                                                <v-chip
                                                    small
                                                    color="blue lighten-4"
                                                    text-color="blue lighten-1"
                                                >
                                                    Charged
                                                </v-chip>
                                            </span>
                                        </span>
                                        <span v-else>
                                            <v-chip
                                                small
                                                color="gray lighten-5"
                                                text-color="gray lighten-1"
                                            >
                                                Not Charged
                                            </v-chip>
                                        </span>


                                        <span v-if="item.credit_decision" style="margin-left: 10px;">
                                            <v-tooltip bottom content-class="intake-tooltip">
                                                <template v-slot:activator="{ on, attrs }">
                                                      <v-chip
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          :color="getSatisfactionColor(convertCreditDecisionToNumber(item.credit_decision))"
                                                          dark
                                                          class="font-weight-black"
                                                          style="height: 24px; padding: 0 7px; font-size: 12px;"
                                                      >
                                                          <span style="font-weight: 900; font-size: 12px;">
                                                              {{ convertCreditDecisionToNumber(item.credit_decision) }}
                                                          </span>
                                                      </v-chip>
                                                </template>

                                                <span class="tooltip-text">
                                                    Credit Decision: {{ item.credit_decision }}
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </template>

                                    <template v-slot:item.from="{ item }">
                                        {{ formatPhoneNumber(item.from) }}
                                    </template>

                                    <template v-slot:item.tag="{ item }">
                                        <div class="pt-2 pb-2">
                                            <span v-for="(tag, index_tag) in item.tag" :key="'tag-' + index_tag" class="pr-2 pb-2">
                                                <v-chip v-if="tag == 0" class="mb-1 dark">
                                                    <span style="font-size: 12px;">Not Set</span>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 1" color="#3EBB80">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Customer</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 2" color="#44468F">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Missed Call</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 3" color="#FFB443" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Opportunity</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 4" color="#2477F6" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Meeting Scheduled</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 5" color="#E53F71">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Became Customer</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Signed'" color="#2137cb" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Signed</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked for Consultation'" color="#2bce7f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked for Consultation</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Declined/Not a lead'" color="#aa242b" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Declined/Not a lead</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Wrong Number'" color="#de2f4d" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Wrong Number</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'No Response'" color="#3f3f3f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">No Response</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Existing Client'" color="#4ad25a" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Existing Client</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Failed Sign Up'" color="#830934" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Failed Sign Up</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Following Up/Working on this one'" color="#9418af" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Following Up/Working on this one</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'E-Doc sent not signed'" color="#5a3a69" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">E-Doc sent not signed</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked to Service'" color="#2bce7f" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked to Service</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Booked for Appointment'" color="#1921ba" v-show="!isOnlyAi()">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Booked for Appointment</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Cancelled'" color="#c6ab24">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Cancelled</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Complete'" color="#1921ba">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Complete</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Incomplete'" color="#c6ab24">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Incomplete</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'AI Test Call'" color="#000000">
                                                    <span style="font-size: 12px; color: #FFFFFF;">AI Test Call</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag == 'Duplicate Call'" color="#6750D7">
                                                    <span style="font-size: 12px; color: #FFFFFF;">Duplicate Call</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>

                                                <v-chip class="mb-1" v-if="tag != 0 && tag != 1 && tag != 2 && tag != 3 && tag != 4 && tag != 5
                                                    && tag != 'Signed'
                                                    && tag != 'Booked for Consultation'
                                                    && tag != 'Declined/Not a lead'
                                                    && tag != 'Wrong Number'
                                                    && tag != 'No Response'
                                                    && tag != 'Existing Client'
                                                    && tag != 'Failed Sign Up'
                                                    && tag != 'Following Up/Working on this one'
                                                    && tag != 'E-Doc sent not signed'
                                                    && tag != 'Booked to Service'
                                                    && tag != 'Booked for Appointment'
                                                    && tag != 'Cancelled'
                                                    && tag != 'Complete'
                                                    && tag != 'Incomplete'
                                                    && tag != 'AI Test Call'
                                                    && tag != 'Duplicate Call'
                                                
                                                " :color="getCustomTagColor(tag)">
                                                    <span style="font-size: 12px; color: #FFFFFF;">{{ tag }}</span>

                                                    <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" class="tags" style="color: #FFFFFF; cursor: pointer;" @click="removeTag(item, tag);">mdi-delete-outline</v-icon>
                                                </v-chip>
                                            </span>
                                        </div>

                                        <v-menu
                                            
                                            

                                                bottom
                                                right

                                                nudge-bottom='25'
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-show="$store.state.auth.owner || me.allow_changing_tags_status" color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1">mdi-plus</v-icon>
                                            </template>

                                            <v-list class="table-menu-actions p-2" style="max-height: 500px; overflow-y: auto;">
                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #44468F;" @click="setTag(item, 2);">Missed Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #FFB443;" @click="setTag(item, 3);">Opportunity</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2477F6;" @click="setTag(item, 4);">Meeting Scheduled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #E53F71;" @click="setTag(item, 5);">Became Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3EBB80;" @click="setTag(item, 1);">Existing Customer</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2137cb;" @click="setTag(item, 'Signed');">Signed</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(item, 'Booked for Consultation');">Booked for Consultation</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #aa242b;" @click="setTag(item, 'Declined/Not a lead');">Declined/Not a lead</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #de2f4d;" @click="setTag(item, '>Wrong Number');">Wrong Number</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #3f3f3f;" @click="setTag(item, 'No Response');">No Response</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #4ad25a;" @click="setTag(item, 'Existing Client');">Existing Client</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #830934;" @click="setTag(item, 'Failed Sign Up');">Failed Sign Up</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #9418af;" @click="setTag(item, 'Following Up/Working on this one');">Following Up/Working on this one</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #5a3a69;" @click="setTag(item, 'E-Doc sent not signed');">E-Doc sent not signed</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #2bce7f;" @click="setTag(item, 'Booked to Service');">Booked to Service</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(item, 'Booked for Appointment');">Booked for Appointment</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200" v-show="!isOnlyAi()">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(item, 'Cancelled');">Cancelled</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #1921ba;" @click="setTag(item, 'Complete');">Complete</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #c6ab24;" @click="setTag(item, 'Incomplete');">Incomplete</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #000000;" @click="setTag(item, 'AI Test Call');">AI Test Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" style="color: #6750D7;" @click="setTag(item, 'Duplicate Call');">Duplicate Call</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item v-for="(custom_tag, tag_index) in custom_tags" :key="'custom-tag-' + tag_index" class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);"><span
                                                        class="table-menu-action-icon" :style="'color: ' + custom_tag.color + ';'" @click="setTag(item, custom_tag.tag);">{{ custom_tag.tag }}</span></a>
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item class="hover:bg-gray-200">
                                                    <v-list-item-title><a href="javascript: void(0);" @click="showAddTag = true">+ Add Tag</a></v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>

                                    <template v-slot:item.value="{ item }">
                                        <div :class="'lsa-show-value lsa-show-value-' + item.id">
                                            <a href="javascript: void(0);" @click="showEditValue(item)">${{ item.value }}<i v-show="$store.state.auth.owner" class="mdi mdi-pencil-outline ml-2"></i></a>
                                        </div>
                                        <div :class="'lsa-edit-value lsa-edit-value-' + item.id" style="display: none; position: relative;">
                                            <input type="text" :value="((item.value > 0) ? item.value : me.settings.customer_value)" style="padding: 5px; border: solid 1px #CCCCCC; width: 100px;" />
                                            <div style="position: absolute; margin-top: -22px; right: -31px;">
                                                <a href="javascript: void(0);" style="color: #3EBB80 !important;" @click="editValue(item)"><i class="mdi mdi-check"></i></a>
                                                <a href="javascript: void(0);" class="" style="color: #E53F71 !important;" @click="cancelEditValue(item)"><i class="mdi mdi-close"></i></a>
                                            </div>
                                            <div style="clear: both;"></div>
                                        </div>
                                    </template>

                                    <!-- NEW: Google LSA Rating column -->
                                    <template v-slot:item.ai_rating="{ item }">
                                    <div class="flex items-center gap-2">
                                        <!-- If already rated, show a green check and the final rating -->
                                        <div v-if="item.rated_at" class="flex items-center gap-2">

                                          <div v-if="item.rated_at" class="">
                                              <v-tooltip bottom content-class="intake-tooltip">
                                                  <template v-slot:activator="{ on, attrs }">
                                                      <v-chip
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          :color="getSatisfactionColor(convertSatisfactionToNumber(item.satisfaction))"
                                                          dark
                                                          class="font-weight-black"
                                                          style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                      >
                                                          <span style="font-weight: 900; font-size: 16px;">
                                                              {{ convertSatisfactionToNumber(item.satisfaction) }}
                                                          </span>
                                                      </v-chip>
                                                  </template>

                                                  <span class="tooltip-text">
                                                      {{ item.summary || item.additional_comments }}
                                                  </span>
                                              </v-tooltip>

                                              <span class="text-sm pl-3">
                                                  <strong>{{ satisfactionLabelByTexts(item.satisfaction) }}</strong>
                                                  <!-- <span v-if="item.reason"> · {{ reasonLabel(item.reason) }}</span> -->
                                              </span>
                                          </div>
                                        </div>

                                        <!-- Not rated yet: show AI suggestion / actions -->
                                        <div v-else class="flex items-center gap-2">
                                            Not Rated
                                        </div>
                                    </div>
                                    </template>

                                    <template v-slot:item.intake_performance="{ item }">
                                        <div v-if="item.sources.indexOf('lsa') != -1 && item.sources.indexOf('bland') == -1" class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.intake_performance" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="getSatisfactionColor(item.intake_performance.rating)"
                                                            dark
                                                            class="font-weight-bold"
                                                            style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                        >
                                                            <span style="font-weight: 900; font-size: 16px;">{{ item.intake_performance.rating }}</span>
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.intake_performance.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn v-if="isLocalHost()" small depressed @click="generateAiIntakePerformance(item)" :loading="aiLoadingInakePerformanceById[item.id]">
                                                    Generate
                                                </v-btn>
                                                <span v-else>N/A</span>
                                            </div>
                                        </div>
                                        <div v-else>N/A</div>
                                    </template>

                                    <template v-slot:item.intake_performance_notes="{ item }">
                                      <div class="p-2">{{ (item && item.intake_performance) ? item.intake_performance.explanation : "N/A" }}</div>
                                    </template>

                                    <template v-slot:item.ai_performance="{ item }">
                                        <div v-if="item.sources.indexOf('bland') != -1" class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.ai_performance" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="getSatisfactionColor(item.ai_performance.rating)"
                                                            dark
                                                            class="font-weight-bold"
                                                            style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                        >
                                                            <span style="font-weight: 900; font-size: 16px;">{{ item.ai_performance.rating }}</span>
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.ai_performance.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn v-if="isLocalHost()" small depressed @click="generateAiPerformance(item)" :loading="aiLoadingAiPerformanceById[item.id]">
                                                    Generate
                                                </v-btn>
                                                <span v-else>N/A</span>
                                            </div>
                                        </div>
                                        <div v-else>N/A</div>
                                    </template>

                                    <template v-slot:item.ai_performance_notes="{ item }">
                                        <div class="p-2">{{ (item && item.ai_performance) ? item.ai_performance.explanation : "N/A" }}</div>
                                    </template>

                                    <template v-slot:item.lead_quality="{ item }">
                                        <div class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.rated_at" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :color="getSatisfactionColor(convertSatisfactionToNumber(item.satisfaction))"
                                                            dark
                                                            class="font-weight-black"
                                                            style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                        >
                                                            <span style="font-weight: 900; font-size: 16px;">
                                                                {{ convertSatisfactionToNumber(item.satisfaction) }}
                                                            </span>
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.summary || item.additional_comments }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                N/A
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_quality_notes="{ item }">
                                        <div class="p-2">
                                          <span v-if="item.sources.indexOf('google_ai') != -1">
                                            This call was identified as an AI generated call from Google.
                                          </span>

                                          {{ (item && item.rated_at) ? (item.summary || item.additional_comments) : "N/A" }}

                                          <span v-if="item.charge_status == 'CHARGED' && item.dispute_status == 'APPROVED'">
                                            This call was sent for a refund and a credit was applied successfully.
                                          </span>
                                        </div>
                                    </template>

                                    <template v-slot:item.id="{ item }">

                                        <div style="position: relative;">

                                            <span v-if="item.notes.length > 0" style="width: 16px;
                                                height: 14px;
                                                line-height: 15px;
                                                font-size: 9px;
                                                background: rgb(255, 112, 67);
                                                color: rgb(255, 255, 255);
                                                padding: 0px !important;
                                                border-radius: 100%;
                                                position: absolute;
                                                font-weight: 600;
                                                text-align: center; position: absolute; top: 0px; left: 9px;">{{ item.notes.length }}</span>

                                            <span v-if="item.photos" style="width: 16px;
                                                height: 14px;
                                                line-height: 15px;
                                                font-size: 9px;
                                                background: rgb(255, 112, 67);
                                                color: rgb(255, 255, 255);
                                                padding: 0px !important;
                                                border-radius: 100%;
                                                position: absolute;
                                                font-weight: 600;
                                                text-align: center; position: absolute; top: 0px; left: 38px;">{{ item.photos.split(",").length }}</span>

                                            <div style="float: right; padding-top: 5px;">
                                                <v-menu
                                                        bottom
                                                        right

                                                        nudge-bottom='25'
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon color="green" v-bind="attrs" v-on="on" :ripple="false" small class="ml-1" style="margin-top: -7px;">mdi-dots-vertical</v-icon>
                                                    </template>

                                                    <v-list class="table-menu-actions">
                                                        <v-list-item v-show="!item.is_lsa_booked && item.sources.indexOf('lsa') != -1" class="hover:bg-gray-200">
                                                            <v-list-item-title><a href="javascript: void(0);" @click="markBooked(item)"><span
                                                                class="table-menu-action-icon"><i
                                                                class="mdi mdi-check-circle-outline"></i></span> Mark Booked</a>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item class="hover:bg-gray-200">
                                                            <v-list-item-title v-show="item.archived == 0"><a href="javascript: void(0);" @click="archiveLead(item)"><span
                                                                class="table-menu-action-icon"><i
                                                                class="mdi mdi-archive-outline"></i></span> Archive</a>
                                                            </v-list-item-title>
                                                            <v-list-item-title v-show="item.archived == 1"><a href="javascript: void(0);" @click="unArchiveLead(item)"><span
                                                                class="table-menu-action-icon"><i
                                                                class="mdi mdi-package-up"></i></span> Unarchive</a>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </div>

                                            <a href="javascript: void(0);" @click="notes_lead = item; show_notes_dialog = true"><i class="mdi mdi-comment-multiple-outline" style="font-size: 16px;"></i></a>

                                            <a href="javascript:void(0);" style="margin-left: 14px;"
                                               @click="openPhotosDialog(item)">
                                                <i class="mdi mdi-image-multiple-outline" style="font-size: 16px;"></i>
                                            </a>
                                        </div>
                                    </template>
                                </v-data-table>
                        </div>
                    </div>
                </v-card>
            </div>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import $ from 'jquery';
import axios from 'axios'
import moment from 'moment'
import StatCard from  "@/views/panel/Call/StatCard.vue"

export default {
    components: {
        StatCard
    },
    computed: {
      ...mapState({
          me: state => state.me.me
      }),
      headers() {
        return [
            { text: 'Customer', value: 'customer_name', width: 200, show: true },
            { text: 'Channels', value: 'sources', show: true },
            { text: 'Lead Received', value: 'lead_creation_date', show: true },
            { text: 'Charge Status', value: 'charge_status', width: 170, show: true },
            { text: 'Google LSA Rating', value: 'ai_rating', align: 'start', sortable: false, width: 200, show: true },
            { text: 'Google LSA Rating Notes', value: 'lead_quality_notes', align: 'start', width: 200, sortable: false, show: true },
            { text: 'IP', value: 'intake_performance', align: 'start', sortable: false, show: true },
            { text: 'Intake Performance (IP) Notes', value: 'intake_performance_notes', align: 'start', sortable: false, width: 220, show: true },
            { text: 'AIP', value: 'ai_performance', align: 'start', sortable: false, show: true },
            { text: 'AI Performance (AIP) Notes', value: 'ai_performance_notes', align: 'start', sortable: false, width: 200, show: true },
            { text: 'Tags', value: 'tag', width: 130, show: this.me },
            { text: 'Value', value: 'value', width: 100, show: this.me },
            { text: 'Actions', value: 'id', width: 100, show: this.me }
        ].filter(h => h.show)
      }
    },
    data() {
        return {
            messages: [],
            loading: true,

            new_note: "",
            show_notes_dialog: false,
            notes_lead: null,
            savingNote: false,

            showBlandRecording: false,
            loading_bland_recording: true,
            bland_recording_data: {},

            showLsaRecordings: false,
            loading_lsa_recordings: true,
            lsa_recording_data: {},

            showLsaMessages: false,
            loading_lsa_messages: true,
            lsa_messages_displayed: [],
            lsa_item: null,

            cutoffDate: null,

            selected: [],

            company_name: "",
            uuid: "",
            ai_started_on: "",

            survey_started_on: "",

            selectedMonth: '',
            months: [],

            startDate: '', // Start date of the selected month
            endDate: '',   // End date of the selected month

            dashboard_data: [],
            dashboard_data_prev: [],
            comparisons: {},

            custom_tags: [],
            custom_statuses: [],

            aiSuggestionById: {}, // { [leadId]: { satisfaction, reason, comment, satisfactionLabel, reasonLabel } }
            aiLoadingById: {},    // { [leadId]: boolean }
            aiLoadingInakePerformanceById: {},    // { [leadId]: boolean }
            aiLoadingAiPerformanceById: {},    // { [leadId]: boolean }
            aiLoadingLeadQualityPerformanceById: {},    // { [leadId]: boolean }

            tags_items: [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 3,
                    text: 'Opportunity'
                },{
                    index: 4,
                    text: 'Meeting Scheduled'
                },{
                    index: 5,
                    text: 'Became Customer'
                },{
                    index: 'Signed',
                    text: 'Signed'
                }
                ,{
                    index: 'Booked for Consultation',
                    text: 'Booked for Consultation'
                }
                ,{
                    index: 'Declined/Not a lead',
                    text: 'Declined/Not a lead'
                }
                ,{
                    index: 'Wrong Number',
                    text: 'Wrong Number'
                }
                ,{
                    index: 'No Response',
                    text: 'No Response'
                }
                ,{
                    index: 'Existing Client',
                    text: 'Existing Client'
                }
                ,{
                    index: 'Failed Sign Up',
                    text: 'Failed Sign Up'
                }
                ,{
                    index: 'Following Up/Working on this one',
                    text: 'Following Up/Working on this one'
                }
                ,{
                    index: 'E-Doc sent not signed',
                    text: 'E-Doc sent not signed'
                }
                ,{
                    index: 'Booked to Service',
                    text: 'Booked to Service'
                }
                ,{
                    index: 'Booked for Appointment',
                    text: 'Booked for Appointment'
                }
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                }, {
                    index: 'Duplicate Call',
                    text: 'Duplicate Call'
                },
            ],

            lineChartMetricsOptions: {
              colors: ["rgb(0, 143, 251)", "rgb(254, 176, 25)", "#16a34a", "rgb(255, 69, 96)", "rgb(119, 93, 208)", "#4284C1", "rgb(0, 227, 150)", "rgb(56, 193, 167)"],
              chart: {
                  id: "line-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  show: false
                },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: [
                {
                  opposite: false,
                  labels: {
                    show: true
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: false,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                },
                {
                  opposite: true,
                  labels: {
                    show: false
                  }
                }
              ],
              stroke: {
                  curve: "smooth",
                  width: [4, 4, 4, 4, 4, 9, 4] // last line thicker
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },

              tooltip: {
                shared: true,
                intersect: false,
                y: [{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + ((y) ? y.toFixed(2) : "") + "%";
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }, {
                  formatter: function (y) {
                    return ": $" + y;
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseFloat(y).toFixed(2);
                  }
                },{
                  formatter: function (y) {
                    return ": " + parseInt(y);
                  }
                }]
              }
          },
          lineChartMetricsSeries: [
              {
                name: "Reviews",
                data: [30, 40, 25, 50, 49, 49],
              },
          ],

          legend: [
            { value: 5, label: "Very good", class: "score-1" },
            { value: 4, label: "Good", class: "score-2" },
            { value: 3, label: "Neutral", class: "score-3" },
            { value: 2, label: "Bad", class: "score-4" },
            { value: 1, label: "Very bad", class: "score-5" },
          ],

          panel: 0,
          panel2: 0,

          hoveredLegend: null,

          legendItems: [
              {
                name: "Impressions",
                color: "rgb(0, 143, 251)",
                description: "Total times your ad was shown to users.",
                disabled: false
              },
              {
                name: "Absolute Top Impressions Rate",
                color: "rgb(254, 176, 25)",
                description: "Percentage of your search ad impressions shown in the most prominent position on the page.", // from API docs :contentReference[oaicite:0]{index=0}
                disabled: false
              },
              {
                name: "Under 30s Response Rate",
                color: "#16a34a",
                description: "Percentage of how many leads were responded in under 30 seconds.", // from API docs :contentReference[oaicite:0]{index=0}
                disabled: false
              },
              {
                name: "Lead Volume",
                color: "rgb(255, 69, 96)",
                description: "The number of leads generated — typically form submissions or qualified contacts.",
                disabled: false
              },
              {
                name: "Clicks",
                color: "rgb(119, 93, 208)",
                description: "Number of times users clicked on your ad.",
                disabled: false
              },
              {
                name: "Total Cost",
                color: "#4284C1",
                description: "Total ad spend over the chosen period.",
                disabled: false
              },
              {
                name: "Lead Quality",
                color: "rgb(0, 227, 150)",
                description: "A score from 1 to 5 indicating how qualified the leads are — higher means more likely to convert.",
                disabled: false
              },
              {
                name: "Credited",
                color: "rgb(56, 193, 167)",
                description: "Leads that were originally charged but later refunded due to invalid submissions, cancellations, or quality adjustments after we started submitting your surveys.",
                disabled: false
              }
            ],

            shouldShowChatConversation: false,
            loading_chat_conversation: false,

            new_ai_message: "",
            sendingAiMessage: false,
            ai_messages_lead: null,

            savingAiFeedback: false,

            show_photos_dialog: false,
            photos: [], // array of photo URLs
            savingPhotos: false,
            lead_id: null, // set this when opening dialog

            uploading: false
            
        }
    },

    methods: {
            initFromUrl() {
                const hash = window.location.hash.slice(1); // "month=2026-02&leadId=319876"
                const params = new URLSearchParams(hash);

                const month = params.get("month");   // "2026-02"
                const leadId = params.get("leadId"); // "319876"

                console.log('month', month);
                console.log('leadId', leadId);

                if (month) {
                  this.selectedMonth = month;
                }

                if (leadId) {
                  this.$nextTick(() => {
                    this.openLeadWhenReady(leadId);
                  });
                }
              },

              openLeadWhenReady(leadId, {
                intervalMs = 250,
                timeoutMs = 15000,
                scroll = true
              } = {}) {
                const start = Date.now();

                const tryClick = () => {
                  const el = document.querySelector(`[data-lead-id="${leadId}"]`);

                  if (el) {
                    if (scroll) el.scrollIntoView({ behavior: "smooth", block: "center" });
                    el.click();
                    return; // done
                  }

                  if (Date.now() - start >= timeoutMs) {
                    console.warn(`Lead ${leadId} not found after ${timeoutMs}ms`);
                    return; // give up
                  }

                  setTimeout(tryClick, intervalMs);
                };

                tryClick();
              },

            openPhotosDialog(lead) {
                this.lead_id = lead.id

                if (lead.photos) {
                    this.photos = lead.photos.split(',')
                } else {
                    this.photos = []
                }

                this.show_photos_dialog = true
            },

            async onUpload() {
              // console.log(this.file);
              if (this.file !== null) {
                this.uploading = true
                let formData = new FormData()
                formData.append("file", this.file)

                try {
                  let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })

                  let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-profile-picture`, {
                    profile_image: response.data.url
                  }, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                  })

                  this.profile.profile_image = response.data.url

                }catch(e){
                  console.log(e)
                }

                this.file = null
                this.uploading = false
              }
            },

            handlePhotoUpload(event) {
                let self = this;
                let files = event.target.files
                this.uploading = true;

                for (let i = 0; i < files.length; i++) {
                    let formData = new FormData()
                    formData.append('file', files[i])

                    axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
                        headers: { 'Authorization': 'Bearer ' + self.$store.state.auth.jwt }
                    })
                    .then(res => {
                        self.photos.push(res.data.url)
                        self.uploading = false;
                    })
                }
            },

            removePhoto(index) {
                this.photos.splice(index, 1)
            },

            savePhotos() {
                let self = this;
                this.savingPhotos = true

                axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/save-lead-photos`, {
                      lead_id: this.lead_id,
                        photos: this.photos.join(',')
                  }, {
                      headers: {
                          'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                      }
                  }).then(() => {
                    self.savingPhotos = false
                    self.show_photos_dialog = false
                    self.getMessages(true)
                })
                .catch(() => {
                    self.savingPhotos = false
                })
            },

            async switchAiResponseEnabled(lead) {
                console.log('lead', lead);

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
                    lead_id: lead.id,
                    ai_enabled: lead.ai_enabled
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                console.log('response', response);
            },

            async sendLsaReply() {
                this.sendingLsaMessage = true;
                
                let self = this;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                    lead_id: self.lsa_messages_lead.id,
                    message: self.new_lsa_message
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                let timezone = this.me.timezone;

                this.lsa_messages_displayed.push({
                    event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                    participant_type: 2,
                    text: self.new_lsa_message
                });

                this.sendingLsaMessage = false;
                this.new_lsa_message = "";

                setTimeout(function() {
                    var objDiv = document.getElementById("lsa-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            async sendAiReply() {
                this.sendingAiMessage = true;
                
                let self = this;

                console.log('this.bland_recording_data', this.bland_recording_data);

                if (this.bland_recording_data.sources && this.bland_recording_data.sources.indexOf('lsa') != -1) {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                        lead_id: this.bland_recording_data.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }
                else {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
                        lead_id: self.ai_messages_lead.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }

                let timezone = this.me.timezone;

                try {
                    this.bland_recording_data.transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    });
                }
                catch (e) {

                }

                try {
                    this.bland_transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        content: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.first_name + " " + this.me.last_name)
                    });
                }
                catch (e) {

                }

                this.sendingAiMessage = false;
                this.new_ai_message = "";

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("ai-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("chat-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }
            },

            async showChatConversation(item) {
                if (this.me.is_medical) return false;
                
                let self = this;

                this.shouldShowChatConversation = true;
                this.loading_chat_conversation = true;
                this.ai_messages_lead = item;

                if (this.ai_messages_lead.ai_enabled == 1)
                    this.ai_messages_lead.ai_enabled = true;
                else
                    this.ai_messages_lead.ai_enabled = false;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
                    lead_id: item.id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                this.bland_transcription = response.data.transcription;
                this.loading_chat_conversation = false;

                setTimeout(function() {
                    var objDiv = document.getElementById("chat-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            handleLegendHover(item) {
                this.hoveredLegend = item.name;

                this.legendItems.forEach(i => {
                  if (i.name !== item.name && !i.disabled) {
                    this.$refs.apexChart.hideSeries(i.name);
                  }
                });
              },

              handleLegendLeave() {
                this.hoveredLegend = null;

                this.legendItems.forEach(i => {
                  if (!i.disabled) {
                    this.$refs.apexChart.showSeries(i.name);
                  }
                });
              },

              toggleSeries(item) {
                item.disabled = !item.disabled;
                this.$refs.apexChart.toggleSeries(item.name);
              },

            async generateAiIntakePerformance(item) {
                this.$set(this.aiLoadingInakePerformanceById, item.id, true);
                try {
                let transcript = item.lsa_transcription;

                if (!transcript)
                    transcript = item.lsa_messages;

                const intake_performance = await this.callOpenAIForIntakePerformance(item.id, transcript);

                console.log('intake_performance', intake_performance);

                item.intake_performance = intake_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingInakePerformanceById, item.id, false);
                }
            },

            async generateAiPerformance(item) {
                this.$set(this.aiLoadingAiPerformanceById, item.id, true);
                try {
                let transcript = item.bland_transcription;

                const ai_performance = await this.callOpenAIForAiPerformance(item.id, transcript);

                console.log('ai_performance', ai_performance);

                item.ai_performance = ai_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingAiPerformanceById, item.id, false);
                }
            },

            async callOpenAIForIntakePerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-intake-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            async callOpenAIForAiPerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-ai-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            isLocalHost() {
                return this.getHost().indexOf('localhost') != -1;
            },

            getMonthlyReport() {
                window.open('/leads-public-survey/' + this.me.uuid + "?cutoff_date=" + moment().subtract(2, 'weeks').format('YYYY-MM-DD'));
            },

            async sendMonthlyReport(item, qualify_status) {
                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/send-monthly-survey-report`, {
                    now: 2
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                })

                this.$swal({
                    title: "Email sent!",
                    text: "The report has been successfully sent to the customer!",
                    showCancelButton: false,
                });
            },

            downloadCsv() {
                this.exporting = true;

                let self = this;

                let csv = 'Customer, Timestamp, Lead Type, Sources, Charge Status, Survey Score, Survey Notes, Intake Score, Intake Notes, AI Score, AI Rating\n';
                this.messages.forEach((row) => {

                    let customer = "";

                    if (row.job_type) {
                        customer = row.job_type + " - ";
                    }

                    if (row.tracking_number) {
                        customer += row.tracking_number;
                    }
                    else if (row.customer_phone_number) {
                        customer += row.customer_phone_number;
                    }

                    let tags = [];

                    for (var i in row.tag) {
                        for (var j in this.tags_items) {
                            if (this.tags_items[j].index == row.tag[i]) {
                                tags.push(this.tags_items[j].text);
                            }
                        }
                    }

                    let lead_status = "Not Set";

                    switch (row.qualify_status) {
                        case 1:
                            lead_status = 'Qualified';
                        break;
                        case -1:
                            lead_status = 'Unqualified';
                        break;
                        case 2:
                            lead_status = 'Spam';
                        break;
                    }

                    if (row.qualify_status != 0 && row.qualify_status != 1 && row.qualify_status != 2 && row.qualify_status != -1) {
                        lead_status = row.qualify_status;
                    }

                    let survey_score = "N/A";
                    let survey_notes = "N/A";
                    let intake_score = "N/A";
                    let intake_notes = "N/A";
                    let ai_score = "N/A";
                    let ai_notes = "N/A";

                    if (row.rated_at) {
                        survey_score = self.convertSatisfactionToNumber(row.satisfaction);

                        survey_notes = row.summary || row.additional_comments;
                    }

                    if (row.intake_performance) {
                        intake_score = row.intake_performance.rating;
                        intake_notes = row.intake_performance.explanation;
                    }

                    if (row.ai_performance) {
                        ai_score = row.ai_performance.rating;
                        ai_notes = row.ai_performance.explanation;
                    }

                    let csv_data = [
                        '"' + customer + '"',
                        '"' + self.displayTimestamp(row.lead_creation_date) + '"',
                        '"' + row.lead_type + '"',
                        '"' + row.sources.replace('bland', 'AI') + '"',
                        // '"' + tags.join(",") + '"',
                        '"' + row.charge_status + '"',
                        '"' + survey_score + '"',
                        '"' + survey_notes + '"',
                        '"' + intake_score + '"',
                        '"' + intake_notes + '"',
                        '"' + ai_score + '"',
                        '"' + ai_notes + '"'
                    ]

                    csv += csv_data.join(',');
                    csv += "\n";
                });

                csv = csv.replace(/null/g, "");
            
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'diyai-leads.csv';
                anchor.click();

                this.exporting = false;
            },

          async markBooked(item) {
                item.marking_booked = true;

                item.is_lsa_booked = true;

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/inbox/mark-lead-booked`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          async archiveLead(item) {

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/archive-lead`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          async unArchiveLead(item) {

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/unarchive-lead`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },
          async saveNote() {
              if (!this.new_note)
                  return;

              this.savingNote = true;
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/add-note`, {
                  lead_id: this.notes_lead.id,
                  note: this.new_note
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.savingNote = false;
              this.notes_lead = response.data.lsa_lead;
              this.new_note = '';

              this.getMessages(true);
          },

          async deleteNote(index) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/delete-note`, {
                  lead_id: this.notes_lead.id,
                  note_index: index
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.notes_lead = response.data.lsa_lead;

              this.getMessages(true);
          },

          async setTag(item, tag) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-tag-message`, {
                  message_id: item.id,
                  tag: tag
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              })

              this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
              this.getMessages(true);
          },

          async removeTag(item, tag) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/remove-tag-message`, {
                  message_id: item.id,
                  tag: tag
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              })

              this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
              this.getMessages(true);
          },
          showEditValue(item) {
              $('.lsa-show-value-' + item.id).hide();
              $('.lsa-edit-value-' + item.id).show();
              setTimeout(function() {
                  $('.lsa-edit-value-' + item.id).focus();
              }, 20);
          },

          cancelEditValue(item) {
              $('.lsa-show-value-' + item.id).show();
              $('.lsa-edit-value-' + item.id).hide();
          },

          async editValue(item) {
              item.value = $('.lsa-edit-value-' + item.id + ' input').val();
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/edit-value-message`, {
                  item: item
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.leadDetailsMobile = response.data.lead; this.showFullLeadDetailsMobileKey++;
              this.getMessages(true);

              $('.lsa-show-value').show();
              $('.lsa-edit-value').hide();
          },


          displaySpeakerTimestamp(milliseconds, firstItemMilliseconds) {
              //Get hours from milliseconds
              var hours = milliseconds / (1000*60*60);

              //if (firstItemMilliseconds < 1000)
                //hours = milliseconds / (100*60*60);

              var absoluteHours = Math.floor(hours);
              var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

              //Get remainder from hours and convert to minutes
              var minutes = (hours - absoluteHours) * 60;
              var absoluteMinutes = Math.floor(minutes);
              var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

              //Get remainder from minutes and convert to seconds
              var seconds = (minutes - absoluteMinutes) * 60;
              var absoluteSeconds = Math.floor(seconds);
              var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

              return h + ':' + m + ':' + s;
        },

        async showBlandRecordingFunction(item) {

          this.ai_messages_lead = item;
          this.ai_messages_lead.show_ai_feedback = false;

          if (this.ai_messages_lead.ai_enabled == 1)
              this.ai_messages_lead.ai_enabled = true;
          else
              this.ai_messages_lead.ai_enabled = false;

          let self = this;

          this.showBlandRecording = true;
          this.loading_bland_recording = true;
          
          this.bland_recording_data.recording_url = item.bland_recording_url;
          this.bland_recording_data.sources = item.sources;
          this.bland_recording_data.lead_type = item.lead_type;
          this.bland_recording_data.id = item.id;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.bland_recording_data.transcription = response.data.transcription;

          let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
          original_ai_messages = original_ai_messages.messages;

          console.log('original_ai_messages', original_ai_messages);

          if (item.lead_type == "MESSAGE" && item.sources.indexOf('lsa') != -1) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                  lead_id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              for (var i in response.data.lsa_messages) {
                  response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                  response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                  response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                  // response.data.lsa_messages[i].is_person = 0;
                  response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                  response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                  for (var j in original_ai_messages) {
                      console.log('compare 1:', response.data.lsa_messages[i].message);
                      console.log('compare 2:', original_ai_messages[j].body);
                      if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                          console.log("FOUD AI MESSAGE");
                          console.log(response.data.lsa_messages[i].message);
                          response.data.lsa_messages[i].is_person = 0;
                          break;
                      }
                  }

                  if (response.data.lsa_messages[i].text.indexOf('did you get my last message') != -1) {
                      response.data.lsa_messages[i].is_person = 0;
                  }
              }

              this.bland_recording_data.transcription.messages = response.data.lsa_messages;
          }

          this.bland_recording_data.summary = response.data.summary;
          this.bland_recording_data.customer_name = item.customer_name;
          this.bland_recording_data.customer_email = item.customer_email;
          this.bland_recording_data.ai_provided_phone_number = item.ai_provided_phone_number;
          this.bland_recording_data.job_type = item.job_type;
          this.bland_recording_data.call_ended_by = item.call_ended_by;
          this.bland_recording_data.sentiment = response.data.sentiment;
          this.bland_recording_data.topics_discussed = response.data.topics_discussed;
          this.bland_recording_data.issues_raised = response.data.issues_raised;
          this.bland_recording_data.analysis = response.data.analysis;
          this.bland_recording_data.variables = response.data.variables;
          this.loading_bland_recording = false;

          if (response.data.recording_url)
              this.bland_recording_data.recording_url = response.data.recording_url;

          setTimeout(function() {
              if (self.bland_recording_data.recording_url) {
                  document.querySelector('#bl-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.bland_recording_data.recording_url + '" style="width: 100%"></audio>';
              }
          }, 500);

          setTimeout(function() {
              var objDiv = document.getElementById("ai-dialog-messages-list");
              objDiv.scrollTop = objDiv.scrollHeight;
          }, 10);
      },

      async showLsaCallRecordings(item) {
          
          let self = this;

          console.log('this.lsa_item', this.lsa_item);

          this.showLsaRecordings = true;
          this.loading_lsa_recording = true;
          this.lsa_item = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_recordings = false;

          this.lsa_recording_data = JSON.parse(JSON.stringify(response.data));

          console.log('this.lsa_recording_data', this.lsa_recording_data);

          if (response.data.recordings.length > 0) {
              let recordings_html = '';

              for (var i in response.data.recordings) {
                  recordings_html += '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayTimestamp(item.lead_creation_date) + '</div><div style="margin-bottom: 15px;"><audio onwindowresize="" controls="true" class="u-hide" src="' + response.data.recordings[i] + '" style="width: 100%"></audio></div>';
              }

              setTimeout(function() {
                  document.querySelector('#lsa-audio-el-here').innerHTML = recordings_html;
              }, 500);
          }
          else {
              document.querySelector('#lsa-audio-el-here').innerHTML = 'No recordings found.';
          }
      },

      async showLsaMessagesFunction(item) {
      
          // console.log('item.sources', item.sources)
          // console.log('itemplmmmm', item);

          // console.log(1);

          // console.log("item.sources.indexOf('bland')", item.sources.indexOf('bland'))

          if (item.sources.indexOf('bland') != -1) {
              console.log(2);
              this.showBlandRecordingFunction(item);
              return;
          }

          console.log(3);

          
          let self = this;

          this.showLsaMessages = true;
          this.loading_lsa_messages = true;
          this.lsa_messages_lead = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_messages = false;

          this.lsa_messages_displayed = response.data.lsa_messages;
          this.loading_lsa_messages = false;
      },

        readCutoffFromQuery() {
          const params = new URLSearchParams(window.location.search);
          const cutoff = params.get("cutoff_date");

          if (cutoff && moment(cutoff, "YYYY-MM-DD", true).isValid()) {
            this.cutoffDate = moment(cutoff, "YYYY-MM-DD").startOf("day");
          } else {
            this.cutoffDate = moment().subtract(2, 'weeks').format('YYYY-MM-DD');
          }
        },

        isNewLead(item) {
          if (!this.cutoffDate || !item.lead_creation_date) return false;

          const leadDate = moment(item.lead_creation_date, "YYYY-MM-DD HH:mm:ss", true);
          if (!leadDate.isValid()) return false;

          return leadDate.isAfter(this.cutoffDate);
        },

        getRowClass(item) {
          return this.isNewLead(item) ? "new-lead-highlight" : "";
        },

        getHost() {
        return window.location.host;
        },

        isOnlyAi() {
            return !this.isAccelerate();
        },

        isAccelerate() {
            //  || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
            return this.getHost() == 'lsa.accelerateyourmarketing.com';
        },

        getCustomTagColor(tag) {
            for (var i in this.custom_tags) {
                if (this.custom_tags[i].tag == tag)
                    return this.custom_tags[i].color;
            }

            return "";  
        },

        getCustomStatusColor(status) {
            for (var i in this.custom_statuses) {
                if (this.custom_statuses[i].status == status)
                    return this.custom_statuses[i].color;
            }

            return "";  
        },

        formatDate: function(date, format = "MM/DD/YYYY") {
            return moment(String(date)).format(format)
        },

        displayTimestamp(date) {
            let timezone = "America/New_York";

            // .tz(timezone)
            return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
        },

        displayDuration(seconds) {
            return date;
        },

        trainAgentWithSelectedCalls() {
            this.selected = [];

            this.$swal({
                title: "Saved",
                text: "Selected calls will be used as knowledge for AI Agent, based on each call's quality!",
                showCancelButton: false,
            });
        },
        
        satisfactionLabel(value) {
            const map = {
                1: 'Very Satisfied',
                2: 'Satisfied',
                3: 'Neutral',
                4: 'Unsatisfied',
                5: 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        satisfactionLabelByTexts(value) {
            const map = {
                "VERY_SATISFIED": 'Very Satisfied',
                "SATISFIED": 'Satisfied',
                "NEUTRAL": 'Neutral',
                "DISSATISFIED": 'Unsatisfied',
                "VERY_DISSATISFIED": 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        convertSatisfactionToNumber(value) {
            const map = {
                "VERY_SATISFIED": 5,
                "SATISFIED": 4,
                "NEUTRAL": 3,
                "DISSATISFIED": 2,
                "VERY_DISSATISFIED": 1
            };
            return map[value] || 3;
        },

        convertCreditDecisionToNumber(value) {
            const map = {
                'Not specified': 3,
                'Unknown in this API version': 3,
                'Credit issued, cap not reached': 5,
                'Credit issued, cap reached': 4,
                'No credit, cap reached': 2,
                'No credit, not eligible': 1

            };
            return map[value] || 3;
        },

        getSatisfactionColor(value) {
            const map = {
                "1": "#ef4444",
                "2": "#fb923c",
                "3": "#facc15",
                "4": "#22c55e",
                "5": "#16a34a"
            };

            return map[value];
        },

        reasonLabel(reason) {
            // If you store reasons as strings already, just return them.
            // If your backend uses codes, map those codes to labels here.
            return reason || '—';
        },

        normalizedProviders(item) {
            // Build a unique set of providers from item.sources ONLY ONCE
            const src = (item.sources || '').toLowerCase()
            const list = []
            const push = (cond, key, title, srcImg, onClick) => {
            if (cond) list.push({ key, title, src: srcImg, onClick })
            }


            // Important: render EACH provider ONCE. We no longer render separate icons for call/message.
            push(src.includes('lsa'), 'lsa', 'This is a Google Local Service Ads lead', require('@/assets/images/lsa.webp'), (row) => {
            // prefer messages when lead_type is MESSAGE, else show call recordings
            if (row.lead_type === 'MESSAGE') this.showLsaMessagesFunction(row)
            else this.showLsaCallRecordings(row)
            })


            push(src.includes('callrail'), 'callrail', 'CallRail', require('@/assets/images/callrail.png'), (row) => this.showCallRailRecordingFunction(row))


            push(src.includes('bland'), 'ai', 'This is a call that we responded to using AI', require('@/assets/images/bland.png'), (row) => this.showBlandRecordingFunction(row))


            push(src.includes('web'), 'web', 'This is a Web Chat conversation', require('@/assets/images/bland.png'), (row) => this.showChatConversation(row))

            push(src.includes('google_ai'), 'google_ai', 'This is a call that came in using Google AI', require('@/assets/images/review-services/www.google.com.png'), (row) => this.showChatConversation(row))


            // Avoid duplicate icons added from merged_lead by ONLY using current row sources.
            // If you want to show merged sources too, dedupe by key:
            // const merged = (row.merged_lead?.[0]?.sources || '').toLowerCase()
            // ... add conditionally if not already in list.


            // De-duplicate by key just in case
            const seen = new Set()
            return list.filter(p => (seen.has(p.key) ? false : seen.add(p.key)))
        },

        displayDuration(time) {
            var sec_num = time // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        },

        formatPhoneNumber(phoneNumberString) {
            const match = phoneNumberString
    .replace(/\D+/g, '').replace(/^1/, '')
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
    const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
    return `${part1}${part2}${part3}`
        },

        playAudio(item) {
            if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
                let elements = document.getElementsByClassName('audio-element-wrapper');

                for (var i in elements) {
                    try {
                        elements[i].style.display = 'none';
                    }
                    catch (e) {}
                }

                let elements2 = document.getElementsByClassName('audio-element');

                for (var i in elements) {
                    try {
                        elements2[i].pause();
                        elements2[i].currentTime = 0;
                    }
                    catch (e) {}
                }

                let elements3 = document.getElementsByClassName('audio-element-icon');

                for (var i in elements) {
                    try {
                        elements3[i].style.display = 'block';
                    }
                    catch (e) {}
                }

                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
                document.getElementById('audio-element-' + item.id).play();

                document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

                
            }
            else {
                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
                document.getElementById('audio-element-' + item.id).pause();
                document.getElementById('audio-element-' + item.id).currentTime = 0;

                document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
            }
        },

        async getMessages(silent = false) {
            let self = this;

            if (!silent)
                this.loading = true;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
                date_filter: this.date_filter,
                search: this.search,
                tag: this.tag,
                qualify_status: this.qualify_status,
                archived_filter: this.archived_filter,
                for_report: 1,
                month: this.selectedMonth
            }, {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
            })

            this.messages = response.data.messages;
            this.lsa_leads_count = response.data.lsa_leads_count;
            this.ai_leads_count = response.data.ai_leads_count;
            this.ai_leads_count_msg = response.data.ai_leads_count_msg;
            this.ai_leads_count_voice = response.data.ai_leads_count_voice;
            this.callrail_leads_count = response.data.callrail_leads_count;
            this.converted_leads_count = response.data.converted_leads_count;
            this.converted_ai_leads_count = response.data.converted_ai_leads_count;
            this.converted_human_leads_count = response.data.converted_human_leads_count;
            this.booked_leads_count = response.data.booked_leads_count;
            this.booked_ai_leads_count = response.data.booked_ai_leads_count;
            this.booked_human_leads_count = response.data.booked_human_leads_count;

            this.company_name = response.data.company_name;
            this.uuid = response.data.uuid;
            this.ai_started_on = response.data.ai_started_on;
            this.survey_started_on = response.data.survey_started_on;

            await this.loadDashboard();
            await this.loadDashboard2();

            this.loading = false;
        },

        getUUID() {
          return (this.me) ? this.me.uuid : this.$route.params.uuid;
        },

        async doCreated() {
            let self = this

            self.generateMonths();
            if (this.months.length > 0) {
                this.selectedMonth = this.months[0].value;
                this.updateMonthDates(this.selectedMonth); // Set the dates for the current month
            }

            self.getMessages();
        },

        generateMonths() {
          const now = new Date();
          const result = [];

          for (let i = 0; i < 6; i++) {
            const date = new Date(
              now.getFullYear(),
              now.getMonth() - i,
              1
            );

            const value = `${date.getFullYear()}-${String(
              date.getMonth() + 1
            ).padStart(2, '0')}`;

            const label = date.toLocaleString('default', {
              month: 'short',
              year: 'numeric'
            });

            result.push({ value, label });
          }

          this.months = result;
        },

        updateMonthDates() {
          if (!this.selectedMonth) return;

          const [year, month] = this.selectedMonth.split('-');
          this.startDate = `${year}-${month}-01`;

          // Get the last day of the month
          const lastDay = new Date(year, month, 0).getDate();
          this.endDate = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
        },

        async loadDashboard() {

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: this.startDate,
                end_date: this.endDate,
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data = response.data.dashboard_data;

            let diff_days = moment(this.endDate).diff(this.startDate, 'days') + 1;

            let date_prev_start = moment(this.startDate).subtract(diff_days, 'days').format('YYYY-MM-DD');
            let date_prev_end = moment(this.endDate).subtract(diff_days, 'days').format('YYYY-MM-DD');

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency != 'Frequency: Auto') {
              date_prev_start = moment(this.startDate).subtract(1, 'months').format('YYYY-MM-DD');
              date_prev_end = moment(date_prev_start).endOf('month').format('YYYY-MM-DD');
            }

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency == 'Frequency: Auto') {
              date_prev_start = moment(this.startDate).subtract(1, 'months').format('YYYY-MM-DD');
              date_prev_end = moment(date_prev_start).add(1, 'months').format('YYYY-MM-DD');
            }

            if (this.selectedMonth == this.months[0].value) {
              // --- NEW: clamp prev_end day-of-month to "today's" day if prev_end is later in that month ---
              const todayDay = moment().date(); // e.g. 16 on Jan 16
              let prevEnd = moment(date_prev_end, 'YYYY-MM-DD');

              if (prevEnd.date() > todayDay) {
                // set to same month as prevEnd, but with today's day (or last day if month is shorter)
                const clampedDay = Math.min(todayDay, prevEnd.daysInMonth());
                prevEnd.date(clampedDay);
                date_prev_end = prevEnd.format('YYYY-MM-DD');
              }
            }

            console.log('date_prev_start', date_prev_start);
            console.log('date_prev_end', date_prev_end);

            function toBinaryStr(str) {
              const encoder = new TextEncoder();
              // 1: split the UTF-16 string into an array of bytes
              const charCodes = encoder.encode(str);
              // 2: concatenate byte data to create a binary string
              return String.fromCharCode(...charCodes);
            }

            this.reviewsScoreData = btoa(toBinaryStr(JSON.stringify(response.data.reviewsScoreData)));


            let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: date_prev_start,
                end_date: date_prev_end,
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data_prev = response2.data.dashboard_data;
            
            this.calculateComparisons();
          },

        async loadDashboard2() {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: "2025-05-01",
                end_date: moment().endOf('month').format('YYYY-MM-DD'),
                all_time: 0,
                selected_frequency: "Monthly",
                tags_selected: '[]',
                public_survey: 1
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            if (this.ai_started_on) {
                for (var i in response.data.dashboard_data.metrics_chart.labels) {
                    if (moment(response.data.dashboard_data.metrics_chart.labels[i]) >= moment(this.ai_started_on)) {
                        response.data.dashboard_data.metrics_chart.labels[i] = response.data.dashboard_data.metrics_chart.labels[i];
                    }
                }
            }

            this.lineChartMetricsOptions.xaxis.categories = response.data.dashboard_data.metrics_chart.labels;

            this.lineChartMetricsOptions.annotations = {
                xaxis: [
                  {
                    x: moment(this.ai_started_on).format('MMM YYYY'),
                    borderColor: "#008FFB",
                    strokeDashArray: 4,
                    label: {
                      borderColor: "#008FFB",
                      style: {
                        color: "#fff",
                        background: "#008FFB"
                      },
                      text: "AI Started " + moment(this.ai_started_on).format('MM/DD')
                    }
                  },
                  {
                    x: moment(this.survey_started_on).format('MMM YYYY'),
                    borderColor: "#FF4560",
                    strokeDashArray: 4,
                    label: {
                      borderColor: "#FF4560",
                      style: {
                        color: "#fff",
                        background: "#FF4560"
                      },
                      text: "Survey Started " + moment(this.survey_started_on).format('MM/DD')
                    }
                  }
                ]
              }

            this.lineChartMetricsSeries = [
              {
                name: 'Impressions',
                data: response.data.dashboard_data.metrics_chart.datasets['Impressions']
              },
              {
                name: 'Absolute Top Impressions Rate',
                data: response.data.dashboard_data.metrics_chart.datasets['Absolute Top Impressions']
              },
              {
                name: 'Under 30s Response Rate',
                data: response.data.dashboard_data.metrics_chart.datasets['Under 30s Response Rate']
              },
              {
                name: 'Lead Volume',
                data: response.data.dashboard_data.metrics_chart.datasets['Lead Volume']
              },
              {
                name: 'Clicks',
                data: response.data.dashboard_data.metrics_chart.datasets['Clicks']
              },
              {
                name: 'Total Cost',
                data: response.data.dashboard_data.metrics_chart.datasets['Cost']
              },
              {
                name: 'Lead Quality',
                data: response.data.dashboard_data.metrics_chart.datasets['Lead Quality']
              },
              {
                name: 'Credited',
                data: response.data.dashboard_data.metrics_chart.datasets['Credited']
              }
            ];
          },

      calculateComparison(data_now, data_previous) {
        data_now = parseFloat(data_now);
        data_previous = parseFloat(data_previous);

        if (data_now == 0 && data_previous == 0)
          return 0.00;

        if (data_now > 0 && data_previous == 0)
          return 100.00;

        if (data_now == 0 && data_previous > 0)
          return 100.00;

        let percentage;

        if (data_now > data_previous) {
          let x = (data_previous/data_now) * 100
          percentage = 100 - x;
        }
        else {
          let x = (data_now/data_previous) * 100
          percentage = 100 - x;
        }

        if (percentage <= 0)
          percentage = percentage * -1;

        percentage = percentage.toFixed(2);

        return percentage;
      },

      calculateComparisons() {
        // Charged Leads Total
        this.comparisons.charged_leads_total = this.calculateComparison(this.dashboard_data.charged_leads_total, this.dashboard_data_prev.charged_leads_total);
        // END Charged Leads Total


        // Not Charged Leads Total
        this.comparisons.not_charged_leads = this.calculateComparison(this.dashboard_data.not_charged_leads, this.dashboard_data_prev.not_charged_leads);
        // END Not Charged Leads Total


        // Total Leads
        this.comparisons.total_leads = this.calculateComparison(this.dashboard_data.total_leads, this.dashboard_data_prev.total_leads);
        // END Total Leads

        
        // Lead Quality
        this.comparisons.lead_quality = this.calculateComparison(this.dashboard_data.lead_quality, this.dashboard_data_prev.lead_quality);
        // END Lead Quality


        // Total Calls
        this.comparisons.total_calls = this.calculateComparison(this.dashboard_data.total_calls, this.dashboard_data_prev.total_calls);
        // END Total Calls


        // Total Connected Calls
        this.comparisons.total_connected_calls = this.calculateComparison(this.dashboard_data.total_connected_calls, this.dashboard_data_prev.total_connected_calls);
        // END Total Connected Calls


        // Total Message Leads
        this.comparisons.total_message_leads = this.calculateComparison(this.dashboard_data.total_message_leads, this.dashboard_data_prev.total_message_leads);
        // END Total Message Leads


        // Qualified Leads
        this.comparisons.charged_leads = this.calculateComparison(this.dashboard_data.stats.charged_leads, this.dashboard_data_prev.stats.charged_leads);
        // END Qualified Leads


        // Approved Disputes
        this.comparisons.approved_disputes = this.calculateComparison(this.dashboard_data.stats.approved_disputes, this.dashboard_data_prev.stats.approved_disputes);
        // END Approved Disputes


        // Converted Customers
        this.comparisons.converted_customers = this.calculateComparison(this.dashboard_data.stats.converted_customers, this.dashboard_data_prev.stats.converted_customers);
        // END Converted Customers

        // Converted Customers AI
        this.comparisons.converted_customers_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_ai, this.dashboard_data_prev.stats.converted_customers_ai);
        // END Converted Customers AI

        // Converted Customers NON AI
        this.comparisons.converted_customers_non_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_non_ai, this.dashboard_data_prev.stats.converted_customers_non_ai);
        // END Converted Customers NON AI


        // Conversion
        this.comparisons.conversion = this.calculateComparison(this.dashboard_data.stats.conversion, this.dashboard_data_prev.stats.conversion);
        // END Conversion


        // ROI
        this.comparisons.roi = this.calculateComparison(this.dashboard_data.stats.roi, this.dashboard_data_prev.stats.roi);
        // END ROI


        // Total Converted Value
        this.comparisons.total_converted_value = this.calculateComparison(this.dashboard_data.stats.total_converted_value, this.dashboard_data_prev.stats.total_converted_value);
        // END Total Converted Value


        // LSA Response Rate
        this.comparisons.lsa_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_response_rate, this.dashboard_data_prev.stats.lsa_response_rate);
        // END LSA Response Rate


        // LSA Response in less than 30s Rate
        this.comparisons.lsa_30_seconds_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_30_seconds_response_rate, this.dashboard_data_prev.stats.lsa_30_seconds_response_rate);
        // END LSA Response in less than 30s Rate


        // LSA Messages Average Response Rate
        this.comparisons.lsa_messages_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_messages_response_rate, this.dashboard_data_prev.stats.lsa_messages_response_rate);
        // END LSA Messages Average Response Rate


        // Total Impressions
        this.comparisons.total_impressions = this.calculateComparison(this.dashboard_data.stats.total_impressions, this.dashboard_data_prev.stats.total_impressions);
        // END Total Impressions


        // Total Clicks
        this.comparisons.total_clicks = this.calculateComparison(this.dashboard_data.stats.total_clicks, this.dashboard_data_prev.stats.total_clicks);
        // END Total Clicks


        // Total Cost
        this.comparisons.total_cost = this.calculateComparison(this.dashboard_data.stats.total_cost, this.dashboard_data_prev.stats.total_cost);
        // END Total Cost
      }
    },

    destroyed() {
        clearTimeout(this.thisProc);
        this.thisProc = null;
    },

    created() {
        this.initFromUrl();
        this.readCutoffFromQuery();
        this.doCreated();
    },

    watch: {
      selectedMonth: {
        async handler(newMonth) {
          // await this.fetchLeads(newMonth);

          // this.$nextTick(() => {
          //   const hash = window.location.hash.substring(1);
          //   const params = new URLSearchParams(hash);
          //   const leadId = params.get('leadId');

          //   if (leadId) {
          //     this.openLeadWhenReady(leadId);
          //   }
          // });
        },
        immediate: true
      }
    }
}
</script>


<style scoped>
.customer-address {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.customer-address .mdi {
  flex-shrink: 0;
  font-size: 14px;
}

.customer-address span {
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.intake-tooltip {
  max-width: 320px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
}

/* Normalize icon look/feel so they don't jump around across rows */
.rg-channel-icon {
    width: 22px;
    height: 22px;
    display: inline-block;
    object-fit: contain;
}

.custom-text-field .v-input__control input {
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid red;
}
.header-inputs {
border-color: white !important;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
color: rgba(0, 0, 0, 0.38);
border-color: white !important;
}

.v-text-field--outlined fieldset {
border: 1px solid white !important;
}

.status-chip {
font-weight: bold;
text-transform: uppercase;
}

.status-Qualified {
color: green !important;
border-color: green !important;

}

.status-inQualified {
color: red;
border-color: red;
}

.custom-badge {
background-color: rgba(0, 230, 130, 0.1) !important;
color: #09ad95 !important;
}

.tags {
color: #e0e0e0;
font-size: small;
padding-left: 5px;

}

.icon-container {
display: flex;
align-items: center;
justify-content: center;
width: 48px;
height: 48px;
border-radius: 50%;
border: 2px solid #ccc;
cursor: pointer;
}

.icon {
font-size: 24px;
}

textarea:focus, input:focus{
    outline: none;
}

.stats-btn .stats-div {
    display: none;
}

.stats-btn:hover .stats-div {
    display: block;
}
</style>

<style scoped>
.score-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.legend-title {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
  white-space: nowrap;
}

.legend-items {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #374151;
}

.legend-badge {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

/* Score colors */
.score-1 { background: #16a34a; } /* very good */
.score-2 { background: #22c55e; } /* good */
.score-3 { background: #facc15; color: #FFFFFF; } /* neutral */
.score-4 { background: #fb923c; } /* bad */
.score-5 { background: #ef4444; } /* very bad */


</style>

<style type="text/css">
  .new-lead-highlight {
    background-color: #fff7cc !important;
    border-left: 4px solid #f5c518 !important;
  }

  .new-lead-highlight td {
    background-color: #fff7cc !important;
  }

  .custom-legend.centered {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 12px;
}

.custom-legend-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
  opacity: 1;
}

.custom-legend-item.dimmed {
  opacity: 0.3;
}

.custom-legend-item.disabled {
  opacity: 0.3;
}


.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 6px;
  display: inline-block;
}

.legend-label {
  font-size: 13px;
  font-weight: 400;
  color: #444;
}

</style>
